// electron-error-handler.service.ts
import { Injectable, Injector } from '@angular/core';
import { LoggerService } from '../feature/services/logger.service';

@Injectable({
  providedIn: 'root',
})
export class ElectronErrorHandlerService {
  // Instead of injecting LoggerService directly, we inject the Injector.
  constructor(private injector: Injector) {}

  /**
   * Handles and logs an Electron error.
   *
   * @param error - The error object to process.
   * @param electronEvent - A string describing where the error occurred.
   */
  public handleError(error: any, electronEvent: string): void {
    const errorObject = error.rejection || error;
    const formattedTime = new Date().toISOString();

    const errorDetails = {
      timestamp: formattedTime,
      event: electronEvent || 'Electron Error',
      errorType: errorObject.name || 'Unknown Error Type',
      message: errorObject.message || 'No error message available',
      stack: this.formatStack(errorObject.stack),
    };

    // Lazily retrieve LoggerService from the injector.
    const logger = this.injector.get(LoggerService);
    try {
      logger.log(errorDetails, 'Electron');
    } catch (loggingError) {
      throw loggingError;
    }
  }

  private formatStack(stack: string): string[] {
    if (!stack) return ['No stack trace available'];
    return stack
      .split('\n')
      .map(line => line.trim())
      .filter(line => line.length > 0 && !line.includes('node_modules'))
      .slice(0, 10);
  }
}
